import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { ALL_USERS } from './constants';
import { formatDateString, formatDate } from '@app/src/utils/helpers';

export const getValues = (state) => state.filterValues;

export const getIdUser = () => {
  let isValidStorage = sessionStorage.length > 0;
  let isAdmin = decodeAccessToken('isAdmin');
  let storageUser = decodeAccessToken('idUser');
  let idUser = isValidStorage ? (isAdmin ? ALL_USERS : storageUser) : ALL_USERS;
  return idUser;
};

export const getStartDate = () => {
  const sevenDays: number = 7;
  let sevenDaysBeforeDate: Date = new Date();
  sevenDaysBeforeDate.setDate(sevenDaysBeforeDate.getDate() - sevenDays);
  let sevenDaysBeforeDateString: string = formatDateString(
    sevenDaysBeforeDate.getDate(),
    sevenDaysBeforeDate.getMonth(),
    sevenDaysBeforeDate.getFullYear()
    );
    const createdDateString: string = decodeAccessToken('dateCreated');
    const isValidStorage: boolean = sessionStorage.length > 0;
    const isWithinSevenDayRange: boolean = formatDate(createdDateString) > formatDate(sevenDaysBeforeDateString);
    return isValidStorage ? (isWithinSevenDayRange ? createdDateString : sevenDaysBeforeDateString) : sevenDaysBeforeDateString;
  };

  export const getEndDate = () => {
    let endDate: Date = new Date();
    return formatDateString(endDate.getDate(), endDate.getMonth(), endDate.getFullYear());
}
